var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaborationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 106.667V117.333H53.3334V106.667C53.321 103.346 52.5334 100.074 51.0335 97.1107C49.5335 94.1477 47.3625 91.5759 44.6934 89.6C46.8086 86.8439 47.9693 83.4741 48 80C48 75.7565 46.3143 71.6869 43.3137 68.6863C40.3132 65.6857 36.2435 64 32 64C27.7566 64 23.6869 65.6857 20.6863 68.6863C17.6857 71.6869 16 75.7565 16 80C16.0307 83.4741 17.1914 86.8439 19.3067 89.6C16.6375 91.5759 14.4666 94.1477 12.9666 97.1107C11.4666 100.074 10.6791 103.346 10.6667 106.667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.693 36.2666C110.809 33.5105 111.969 30.1408 112 26.6666C112 22.4232 110.314 18.3535 107.314 15.3529C104.313 12.3523 100.244 10.6666 96.0001 10.6666C91.7566 10.6666 87.687 12.3523 84.6864 15.3529C81.6858 18.3535 80.0001 22.4232 80.0001 26.6666C80.0308 30.1408 81.1915 33.5105 83.3067 36.2666C80.6376 38.2426 78.4666 40.8144 76.9666 43.7773C75.4667 46.7402 74.6791 50.0124 74.6667 53.3333V64H117.333V53.3333C117.321 50.0124 116.533 46.7402 115.034 43.7773C113.534 40.8144 111.363 38.2426 108.693 36.2666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 58.6666H37.3334V37.3333H69.3334V26.6666H26.6667V58.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6667 90.6666H58.6667V101.333H101.333V69.3333H90.6667V90.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborationIcon);
export default __webpack_public_path__ + "static/media/Collaboration-Icon.32923f0e5683cfb1a6396a17a10ddc15.svg";
export { ForwardRef as ReactComponent };